// @see https://fontawesome.com/search?q=file&o=r
export const mimeTypesIcon = {
  image: 'image',
  audio: 'audio',
  video: 'video',
  // Documents
  'application/pdf': 'pdf',
  'application/msword': 'word',
  'application/vnd.ms-word': 'word',
  'application/vnd.oasis.opendocument.text': 'word',
  'application/vnd.openxmlformats-officedocument.wordprocessingml': 'word',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'word', // docx
  'application/vnd.ms-excel': 'excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml': 'excel',
  'application/vnd.oasis.opendocument.spreadsheet': 'excel',
  'application/vnd.ms-powerpoint': 'powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml': 'powerpoint',
  'application/vnd.oasis.opendocument.presentation': 'powerpoint',
  'text/plain': 'lines',
  'text/csv': 'csv',
  'text/html': 'code',
  'application/json': 'code',
  // Archives
  'application/gzip': 'zipper',
  'application/zip': 'zipper'
}

export const UNITS = ['byte', 'kilobyte', 'megabyte', 'gigabyte', 'terabyte', 'petabyte']

export function humanReadableSize(bytes) {
  let unitIndex = 0

  while (parseInt(bytes, 10) >= 1024 && unitIndex < UNITS.length - 1) {
    bytes /= 1024
    ++unitIndex
  }

  return new Intl.NumberFormat('fr-FR', {
    style: 'unit',
    unit: UNITS[unitIndex],
    notation: 'compact',
    unitDisplay: 'narrow',
    maximumSignificantDigits: 3
  }).format(bytes)
}

export function fileToImage(file) {
  return new Promise((resolve) => {
    fileToDataUrl(file).then(dataUrl => {
      const img = new Image()
      img.src = dataUrl

      img.onload = () => {
        resolve(img)
      }
    })
  })
}

export function fileToDataUrl(file) {
  return new Promise((resolve) => {
    const reader = new FileReader()

    reader.onload = (/*event*/) => {
      resolve(reader.result)
    }
    reader.readAsDataURL(file)
  })
}

export function computeImageResizeDimensions(img, maxWidth = 300, maxHeight = 100) {
  let width = img.width
  let height = img.height

  // Constraint the image to a box and don't distord it
  if (width > maxWidth) {
    height = height * (maxWidth / width)
    width = maxWidth
  }
  if (height > maxHeight) {
    width = width * (maxHeight / height)
    height = maxHeight
  }

  return {
    width,
    height
  }
}

export function resizeImage(img, maxWidth = 300, maxHeight = 300) {
  const { width, height } = computeImageResizeDimensions(img, maxWidth, maxHeight)

  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height

  canvas.getContext('2d').drawImage(img, 0, 0, width, height)
  return canvas.toDataURL()
}

export function cropCanvasImage(canvas) {
  const originalCtx = canvas.getContext('2d')

  const originalWidth = canvas.width
  const originalHeight = canvas.height
  const imageData = originalCtx.getImageData(0, 0, originalWidth, originalHeight)

  let minX = originalWidth + 1
  let maxX = -1
  let minY = originalHeight + 1
  let maxY = -1
  let currentPixelColorValueIndex

  for (let y = 0; y < originalHeight; y++) {
    for (let x = 0; x < originalWidth; x++) {
      currentPixelColorValueIndex = (y * originalWidth + x) * 4
      const currentPixelAlphaValue = imageData.data[currentPixelColorValueIndex + 3]
      if (currentPixelAlphaValue > 0) {
        if (minX > x) {
          minX = x
        }
        if (maxX < x) {
          maxX = x
        }
        if (minY > y) {
          minY = y
        }
        if (maxY < y) {
          maxY = y
        }
      }
    }
  }

  const croppedWidth = maxX - minX
  const croppedHeight = maxY - minY
  if (croppedWidth < 0 || croppedHeight < 0) {
    return null
  }
  const cuttedImageData = originalCtx.getImageData(minX, minY, croppedWidth, croppedHeight)

  const croppedCanvas = document.createElement('canvas')
  const croppedCtx = croppedCanvas.getContext('2d')

  croppedCanvas.width = croppedWidth
  croppedCanvas.height = croppedHeight
  croppedCtx.putImageData(cuttedImageData, 0, 0)

  return croppedCanvas.toDataURL() // as PNG
}
